import React, { useEffect } from "react";
import {BLOCKS} from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";
import Button from "../../atoms/button/button";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

// Styles //
import "./modalRegistroForm.scss";

interface ModalRegistroFormProps extends React.ComponentProps<"div"> {
    showModal: boolean;
    tituloPrincipal: string;
    descripcionFormulario: any;
    imagenesFormulario: any;
    tituloBoton: string;
    redireccionBoton: string;
    isOpenModalFailure?: boolean;
}

const ModalRegistroForm: React.FC<ModalRegistroFormProps> = (props: ModalRegistroFormProps) => {
    const { showModal,
            tituloPrincipal,
            descripcionFormulario,
            imagenesFormulario,
            tituloBoton,
            redireccionBoton,
            isOpenModalFailure
    } = props
    const { isBrowser, document } = useBrowserMode();
    const pathName = isBrowser ? window.location.pathname: '';

    // Funcion para renderizar contenido de texto de tipo json provenientes de contentful
    const contentfulRenderOptions = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="m-modal-registro__form__item__msg" >{children}</p>;
            },
        },
        renderText: (text) =>
        text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };
    
    useEffect(() => {
        document.body.style.overflow = showModal ? "scroll" : "unset"
    }, [props.showModal])

    return (
        <div className="m-modal-registro__box">  
            <div className="m-modal-registro">
                <div className="m-modal-registro__form">
                    <div className="m-modal-registro__form__items registered">
                        {isOpenModalFailure ?
                            (   
                                <div className="m-modal-registro__form__items__icon-failure">
                                    <img src={imagenesFormulario.file.url} alt={"Icono de error"}/>
                                </div>
                            )
                            :
                            (
                                <div className="m-modal-registro__form__items__icon">
                                    <img className="m-modal-registro__form__items__icon--light" 
                                        src={imagenesFormulario[0].file.url} 
                                        alt={"Mano exito"} 
                                    />
                                    <img className="m-modal-registro__form__items__icon--dark" 
                                        src={imagenesFormulario[1].file.url} 
                                        alt={"Mano exito"} 
                                    />
                                </div>
                            )
                        }
                        <div className="m-modal-registro__form__item__title">{tituloPrincipal}</div>
                        <div className="m-modal-registro__form__item__msg">
                            {rawToReact(descripcionFormulario.raw, contentfulRenderOptions)}
                        </div>
                    </div>
                    <div className="m-modal-registro__form__button">
                        <Button
                            type="link"
                            text={tituloBoton}
                            classname={`a-button__magenta dimensions gtm_${pathName.split('/')[3]}_${pathName.split('/')[4]}_entendido_modal_exitoso`}
                            isDisabled={false}
                            href={redireccionBoton}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalRegistroForm;